import { EnumSideOptions, TypeNoteOption } from "../../sharedTypes";

// X-ray Category
export interface IXrayInfo {
    [EnumXrayOptions.Abdomen]: IAbdomen;
    [EnumXrayOptions.Chest]: boolean;
    [EnumXrayOptions.ParanasalSinuses]: boolean;
    [EnumXrayOptions.RibWithPAChest]: EnumRibWithChestOption;
    [EnumXrayOptions.Skull]: boolean;
    [EnumXrayOptions.ScoliosisExam]: boolean;
    [EnumXrayOptions.Spine]: EnumXraySpineOption[];
    [EnumXrayOptions.Je]?: JointsAndExtremities;
    [EnumXrayOptions.Be]: BariumEnema[];
    [EnumXrayOptions.Beg]?: BariumEsophagram[];
    [EnumXrayOptions.SmallBowel]: boolean;
    [EnumXrayOptions.UpperGI]: boolean;
    [EnumXrayOptions.Hsg]: boolean;
    [EnumXrayOptions.Other]: TypeNoteOption;
}


export enum EnumXrayOptions {
    Abdomen = 'abdomen',
    Chest = 'chest',
    ParanasalSinuses = 'paranasalSinuses',
    RibWithPAChest = 'ribWithPAChest',
    Skull = 'skull',
    ScoliosisExam = 'scoliosisExam',
    Spine = 'spine',
    Je = 'jointsAndExtremities',
    Be = 'bariumEnema',
    Beg = 'bariumEsophagram',
    SmallBowel = 'smallBowel',
    UpperGI = 'upperGI',
    Hsg = 'hsg',
    Other = 'other'
}

// Spine Options
export enum EnumXraySpineOption {
    Cervical = "cervical",
    Thoracic = "thoracic",
    Lumbosacral = "lumbosacral"
}

// Rib with Chest Options
export enum EnumRibWithChestOption {
    Both = "both",
    Left = "left",
    Right = "right"
}

// Abdomen Options

export interface IAbdomen {
    value: boolean,
    options: EnumXrayAbdomenOption[]
}

export enum EnumXrayAbdomenOption {
    One = "one",
    Two = "two",
    Three = "three"
}

export interface JointsAndExtremities {
    note?: string;
    options: EnumSideOptions;
}

export enum BariumEnema {
    WithAirContrast = "with air-contrast"
}

export enum BariumEsophagram {
    BariumTablet = "barium tablet"
}

// Barium Enema Options
export enum EnumBariumEnemaOption {
    WithAirContrast = "with_air_contrast"
}

// Barium Esophagram Options
export enum EnumBariumEsophagramOption {
    BariumTablet = "barium_tablet"
}
